import { Box, Flex, Heading, Input, VStack } from '@chakra-ui/react';
import React, { useEffect, useCallback } from 'react';
import { getPackages, searchPackages } from '../../../api/packages';
import usePackageStore from '../../../store/packageStore';
import { PackageCard } from '../../Landing/Packages/PackageCard';

export const AllPackages = () => {
  const { packages, setPackages } = usePackageStore();

  React.useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const res = await getPackages();
      setPackages(res);
    } catch (error) {
      console.error('error while loading all packages', error);
    }
  }, [setPackages]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = async e => {
    e.preventDefault();
    const res = await searchPackages(e.target.value);
    setPackages(res);
  };

  return (
    <VStack
      p={[5, 10]}
      spacing={12}
      alignItems={'center'}
      width={'100%'}
      justifyContent={'center'}
    >
      <Flex flexDir={'column'} gap={[5, 9]} alignItems={'center'}>
        <Heading color="teal" fontSize={[24, 30]}>
          Explore All Packages
        </Heading>
        <Input
          variant="outline"
          placeholder="Search For Package"
          size={'lg'}
          width={['80vw', '35vw']}
          onChange={e => handleSearch(e)}
        />
      </Flex>
      <Box
        display="grid"
        gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
        gap={[6, 8]}
        width="full"
        justifyContent="center"
      >
        {packages.map((item) => {
          return (
            <Flex key={item._id || item.id} justify="center">
              <PackageCard packages={item} />
            </Flex>
          );
        })}
      </Box>
    </VStack>
  );
};
